<template>
  <v-row align="center" justify="center">
    <v-col cols="12" md="6">
      <SectionTitle>O atendimento tradicional trava o seu salão</SectionTitle>
      <ul class="pains-list mt-6">
        <li v-for="(item, i) in pains" :key="i">
          <v-icon color="red">mdi-close</v-icon>
          {{ item }}
        </li>
      </ul>
      <p class="highlighted-text mt-6">🎉 O tablet de mesa resolve tudo isso.</p>
      <div class="mt-2">
        <CtaButton>Quero resolver</CtaButton>
      </div>
    </v-col>

    <v-col cols="12" md="6" class="pains-visual">
      <img
        :src="require('@/assets/images/tablet-pains.webp')"
        class="pains-img"
        alt="Garçom sobrecarregado tentando anotar pedidos, receber pagamentos e servir mesas ao mesmo tempo"
        loading="lazy"
        decoding="async"
      />

      <v-chip
        v-for="(chip, i) in chips"
        :key="i"
        class="chip-label"
        :class="`chip-${i + 1}`"
      >
        <v-icon small color="red" class="mr-2">{{ chip.icon }}</v-icon>{{ chip.text }}
      </v-chip>
    </v-col>
  </v-row>
</template>

<script>
  import CtaButton from '@/components/CtaButton.vue';
  import SectionTitle from '@/components/SectionTitle.vue';

  export default {
    name: 'TabletPainsSection',

    components: {
      CtaButton,
      SectionTitle,
    },

    data: () => ({
      pains: [
        'Cliente esperando até alguém anotar o pedido',
        'Erros de anotação e pedidos errados',
        'Funcionários faltando e sobrecarregados',
        'Mão de obra cara e difícil de contratar',
      ],

      chips: [
        { icon: 'mdi-account-clock', text: 'Cliente esperando' },
        { icon: 'mdi-pencil-off', text: 'Pedido errado' },
        { icon: 'mdi-account-group', text: 'Garçom sobrecarregado' },
        { icon: 'mdi-table-chair', text: 'Mesa parada = menos vendas' },
        { icon: 'mdi-cash-remove', text: 'Custo alto de mão de obra' },
      ],
    }),
  };
</script>

<style scoped lang="scss">
  .pains-list {
    list-style-type: none;
    padding-left: 0;

    li {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 17px;
      color: var(--text-secondary);
      margin-bottom: 14px;

      @media (max-width: 780px) {
        font-size: 15px;
      }
    }
  }

  .highlighted-text {
    display: inline-block;
    padding: 10px 18px;
    border-radius: 10px;
    border: 1px solid rgba(35, 207, 101, 0.5);
    background: linear-gradient(135deg, rgba(35, 207, 101, 0.1) 0%, rgba(35, 207, 101, 0.02) 100%);
    font-weight: 500;
  }

  .pains-visual {
    position: relative;

    @media (max-width: 780px) {
      margin-top: 12px;
    }
  }

  .pains-img {
    display: block;
    width: 100%;
    max-width: 340px;
    height: auto;
    margin: 0 auto;
    aspect-ratio: 900 / 1080;

    @media (max-width: 780px) {
      max-width: 270px;
    }
  }

  .chip-label {
    position: absolute;
    z-index: 2;
    padding: 8px 12px;
    border: 1px solid #e50914;
    border-radius: 12px;
    background-color: var(--chip-bg) !important;
    font-size: 16px;
    font-weight: 500;

    @media (max-width: 780px) {
      font-size: 13px;
      padding: 6px 10px;
    }
  }

  .chip-1 { top: 1%;  left: 0;  animation: chip-float-a 4.3s ease-in-out infinite; }
  .chip-2 { top: 22%; right: 0; animation: chip-float-b 3.7s ease-in-out infinite 0.8s; }
  .chip-3 { top: 43%; left: 0;  animation: chip-float-c 5.1s ease-in-out infinite 0.4s; }
  .chip-4 { top: 57%; right: 0; animation: chip-float-d 4.6s ease-in-out infinite 1.2s; }
  .chip-5 { top: 85%; left: 0;  animation: chip-float-a 4.9s ease-in-out infinite 0.6s; }

  @keyframes chip-float-a {
    0%,100% { transform: translate(0,0); }
    50%     { transform: translate(4px,-7px); }
  }
  @keyframes chip-float-b {
    0%,100% { transform: translate(0,0); }
    50%     { transform: translate(-5px,-6px); }
  }
  @keyframes chip-float-c {
    0%,100% { transform: translate(0,0); }
    50%     { transform: translate(5px,-8px); }
  }
  @keyframes chip-float-d {
    0%,100% { transform: translate(0,0); }
    50%     { transform: translate(-4px,-5px); }
  }
</style>
